import PopupTemplate from '@arcgis/core/PopupTemplate';
import ActionButton from '@arcgis/core/support/actions/ActionButton';

/**
 * Creates the popup template used for all event parking features — both
 * polygon lot layers and point layers (shuttle stops, ADA stalls, etc.).
 *
 * The title and content are generated via functions so that null/absent
 * fields are handled gracefully regardless of feature type.
 */
export const createEventParkingPopupTemplate = () => {
  const directionsAction = new ActionButton({
    title: 'Directions',
    id: 'directions-action',
    icon: 'compass',
  });

  return new PopupTemplate({
    actions: [directionsAction] as any,

    // Build the title from whatever fields are available
    title: (feature: any) => {
      const attributes = feature.graphic?.attributes || {};
      const eventName = attributes.event_name as string | null;
      const permissions = attributes.parking_permissions as string | null;

      if (eventName && permissions) return `${eventName} - ${permissions}`;
      if (permissions) return permissions;
      if (eventName) return eventName;
      return 'Event Parking';
    },

    content: (feature: any) => {
      const attributes = feature.graphic?.attributes || {};
      const lotNumber = attributes.LOTNUMBER as string | null;
      const permissions = attributes.parking_permissions as string | null;
      const description = attributes.description as string | null;
      const eventName = attributes.event_name as string | null;

      const rows = [
        lotNumber   ? `<p><strong>Lot:</strong> ${lotNumber}</p>` : '',
        permissions ? `<p><strong>Type:</strong> ${permissions}</p>` : '',
        eventName   ? `<p><strong>Event:</strong> ${eventName}</p>` : '',
        description ? `<p><strong>Description:</strong> ${description}</p>` : '',
      ]
        .filter(Boolean)
        .join('');

      return `<div style="padding: 10px;">${rows || '<p>No additional information.</p>'}</div>`;
    },
  });
};

export default createEventParkingPopupTemplate;
